import { Link as LinkIcon } from "lucide-react";

interface ProjectLinksCardProps {
  externalLink?: string;
  videoUrl?: string;
  videoThumbnail?: string;
}

export function ProjectLinksCard({
  externalLink,
  videoUrl,
  videoThumbnail,
}: ProjectLinksCardProps) {
  return (
    <div className="bg-[#0C1427] rounded-[10px] p-[20px] h-[381px] w-full flex flex-col gap-[28px] items-center overflow-clip">
      <div className="flex flex-col gap-[20px] items-start w-full">
        {/* Title */}
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[16px] whitespace-pre">
          Links
        </p>

        <div className="flex flex-col gap-[20px] items-start w-full">
          {/* External Link Section */}
          <div className="flex flex-col gap-[10px] items-start w-full">
            <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[14px] w-full">
              Imagens e Conceito
            </p>

            {externalLink ? (
              <a
                href={externalLink}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-[#7846FF] flex gap-[6px] items-center justify-center px-[60px] py-[6px] rounded-[30px] w-[122px]"
              >
                <LinkIcon className="h-[16px] w-[15px] text-[#F5F2FF]" />
                <p className="font-['Plus_Jakarta_Sans'] font-semibold leading-[1.4] text-[#f5f2ff] text-[12px] text-center whitespace-pre">
                  Link Externo
                </p>
              </a>
            ) : (
              <div className="text-[#888888] text-[14px]">-</div>
            )}
          </div>

          {/* Video Teaser Section */}
          <div className="flex flex-col gap-[10px] items-start w-full">
            <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[14px] w-full">
              Vídeo promo/teaser
            </p>

            <div className="h-[191px] w-full rounded-[6px] overflow-hidden bg-[#15203C]">
              {videoUrl ? (
                <iframe
                  src={videoUrl}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Project Teaser Video"
                />
              ) : videoThumbnail ? (
                <img
                  src={videoThumbnail}
                  alt="Video thumbnail"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-[#888888] text-[14px]">
                  Sem vídeo disponível
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
